import React from "react";

// mark = sirf gol emblem (assets/brand/mark.svg — purane logo.svg me poora logo tha, wordmark samet,
// isliye header me naam do baar dikhta tha).
import mark from "../assets/brand/mark.svg";
import wordmarkDark from "../assets/CHAWLA ISPAT.svg";
import wordmarkLight from "../assets/brand/wordmark-light.svg";
import taglineDark from "../assets/THE IRON JUNCTION.svg";
import taglineLight from "../assets/brand/tagline-light.svg";

/**
 * Chawla Ispat ka logo — ek hi jagah se (ticket 2.1).
 *
 * Teen tukde hain aur teeno alag SVG file hain:
 *   mark     — gol emblem (rang nahi badalta)
 *   wordmark — "CHAWLA ISPAT", navy + orange
 *   tagline  — "THE IRON JUNCTION"
 *
 * `variant="light"` ka matlab hai "gehre background par lagana hai"
 * (mobile ka navy header, footer, login screen) — us haalat me wordmark ki
 * navy line aur tagline safed ho jaate hain; orange waisa hi rehta hai,
 * kyunki brand ka orange hi asli pehchaan hai. Safed version alag SVG file
 * hai (assets/brand/*), CSS filter se nahi — filter orange ko bhi kha jata.
 */
export interface BrandLogoProps {
  /** "dark" = safed/halke background par (default). "light" = navy background par. */
  variant?: "dark" | "light";
  /** Emblem ka size px me. Canvas: desktop header 54, mobile 36. */
  markSize?: number;
  /** Wordmark ki chaudai px me. Canvas: desktop header 214. */
  wordmarkWidth?: number;
  /** Chhoti jagah (mobile header) par tagline chhod dete hain. */
  showTagline?: boolean;
  className?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  variant = "dark",
  markSize = 54,
  wordmarkWidth = 214,
  showTagline = true,
  className = "",
}) => {
  const onDark = variant === "light";

  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      aria-label="Chawla Ispat — The Iron Junction"
    >
      {/* Navy background par emblem ka blue swoosh ghul jaata tha — wahan
          safed gol tile par rakhte hain (poster/WhatsApp creative jaisa). */}
      <span
        className={`inline-flex shrink-0 items-center justify-center ${
          onDark ? "rounded-xl bg-white" : ""
        }`}
        style={onDark ? { padding: Math.round(markSize * 0.12) } : undefined}
      >
        <img
          src={mark}
          alt=""
          aria-hidden="true"
          height={markSize}
          style={{ width: "auto", height: markSize }}
          className="shrink-0 object-contain"
          decoding="async"
        />
      </span>
      <span className="flex flex-col justify-center">
        <img
          src={onDark ? wordmarkLight : wordmarkDark}
          alt="Chawla Ispat"
          style={{ width: wordmarkWidth }}
          className="block"
          decoding="async"
        />
        {showTagline ? (
          <img
            src={onDark ? taglineLight : taglineDark}
            alt=""
            aria-hidden="true"
            style={{ width: Math.round(wordmarkWidth * 0.86) }}
            className="mt-[3px] block"
            decoding="async"
          />
        ) : null}
      </span>
    </span>
  );
};

export default BrandLogo;
